import React from 'react';
import { Card, Accordion, Title4 } from '@hz-design-system/web-ui';
import Question from '@/client/components/FaqFooter/atoms/Question';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import FaqReporting from '@/client/components/FaqReporting';

interface FaqFooterProps {
  seoFaqData?: { questions: Record<string, string>; answers: Record<string, string> };
  searchRequestObject?: TSearchRequestObject;
}

const FaqFooter: React.FC<FaqFooterProps> = ({ seoFaqData, searchRequestObject }) => {
  const { t } = useI18nContext();

  if (!seoFaqData?.questions || !seoFaqData?.answers) {
    return null;
  }

  const { questions, answers } = seoFaqData;
  const faqDataArray = Object.keys(questions).map((key) => ({
    question: questions[key],
    answer: answers[key],
  }));

  // Ensure we have an array with data
  if (!Array.isArray(faqDataArray) || faqDataArray.length === 0) {
    return null;
  }

  return (
    <div className="faqFooter">
      <div className="heading">
        <div></div>
        <div>
          <Title4>{t('seo.faq.title')}</Title4>
          <p>{t('seo.faq.disclaimer')}</p>
        </div>
        <FaqReporting searchRequestObject={searchRequestObject} />
      </div>
      <Card className="hz-Card-block">
        <div itemScope itemType="https://schema.org/FAQPage">
          <Accordion>
            {faqDataArray.map(({ question, answer }) => (
              <Question question={question} answer={answer} key={question} />
            ))}
          </Accordion>
        </div>
      </Card>
    </div>
  );
};

export default FaqFooter;
